import { Component, Inject, OnDestroy } from '@angular/core'
import { Dialog } from '@angular/cdk/dialog'
import { JobSelectionDialogComponent } from '../../jobs/job-selection-dialog/job-selection-dialog.component'
import { Subject, takeUntil } from 'rxjs'
import { selectCaseId, selectIsSharedCase } from '../../state/case/case.selectors'
import { Store } from '@ngrx/store'
import { DatasetApiService } from '../../shared/services/dataset-api.service'
import { ToasterService } from '../../shared/services/toaster.service'
import { DOCUMENT } from '@angular/common'
import { Clipboard } from '@angular/cdk/clipboard'
import { selectCaseName } from '../../state/case/case.selectors'
import { viewerActions } from 'src/app/state/viewer/viewer.actions'
import { selectionActions } from 'src/app/state/selection/selection.actions'

@Component({
    selector: 'app-viewer-controls-panel',
    templateUrl: './viewer-controls-panel.component.html',
    styleUrls: ['./viewer-controls-panel.component.scss'],
})
export class ViewerControlsPanelComponent implements OnDestroy {
    readonly caseName$ = this.store.select(selectCaseName)
    readonly isSharedCase$ = this.store.select(selectIsSharedCase)
    searchKey = ''

    private readonly destroy$ = new Subject<void>()

    constructor(
        private readonly store: Store,
        private readonly dialog: Dialog,
        private readonly datasetApi: DatasetApiService,
        private readonly toaster: ToasterService,
        private readonly clipboard: Clipboard,
        @Inject(DOCUMENT) private readonly document: Document
    ) {
        this.store
            .select(selectCaseId)
            .pipe(takeUntil(this.destroy$))
            .subscribe(_ => {
                this.searchKey = ''
            })
    }

    showJobSelection(_: MouseEvent): void {
        this.dialog.open(JobSelectionDialogComponent, { autoFocus: 'dialog' })
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    createDatasetSharingLink(): void {
        this.datasetApi
            .getDatasetSharingLink()
            .pipe(takeUntil(this.destroy$))
            .subscribe(({ url }) => {
                const window = this.document.defaultView
                if (!window) return

                const link = `${window.location.origin}/shared/cases/${url}`
                this.clipboard.copy(link)
                this.toaster.success(link, 'Sharing link copied to clipboard')
            })
    }

    updateSearchKey(event: Event): void {
        const input = event.target as HTMLInputElement
        const searchKey = input.value
        this.searchKey = searchKey
        this.store.dispatch(viewerActions.setSearchKey({ searchKey }))
        this.store.dispatch(selectionActions.setSearchKey({ searchKey }))
    }
}
